export const formatDecimal = (value, digits = 2, options = {}) => {
  const { zeroAsDash = false, dash = "-" } = options;
  if (value === null || value === undefined || value === "") return dash;
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return value;
  if (zeroAsDash && parsed === 0) return dash;
  return parsed.toFixed(digits);
};

export const getUnitFromMetric = (metric, dash = "-") => {
  if (!metric) return dash;
  const match = String(metric).match(/\(([^)]+)\)/);
  return match?.[1] || dash;
};

export const DEFAULT_RESOURCE_UNITS_BY_COMMODITY = {
  gold: { gradeUnit: "g/t", containedUnit: "Moz" },
  silver: { gradeUnit: "g/t", containedUnit: "Moz" },
  copper: { gradeUnit: "%", containedUnit: "Mt" },
  nickel: { gradeUnit: "%", containedUnit: "Mt" },
  lead: { gradeUnit: "%", containedUnit: "Mt" },
  zinc: { gradeUnit: "%", containedUnit: "Mt" },
  molybdenum: { gradeUnit: "%", containedUnit: "Mt" },
  lithium: { gradeUnit: "% Li2O", containedUnit: "Mt LCE" },
  uranium: { gradeUnit: "% U3O8", containedUnit: "Mlb U3O8" },
};

export const getDefaultResourceUnits = (commodity) => {
  if (!commodity) return null;
  const key = String(commodity).trim().toLowerCase();
  return DEFAULT_RESOURCE_UNITS_BY_COMMODITY[key] || null;
};

export const resolveResourceUnit = (unit, commodity, unitType, fallback = "-") => {
  if (unit && String(unit).trim().toLowerCase() !== "unit") return unit;
  const defaults = getDefaultResourceUnits(commodity);
  return defaults?.[unitType] || fallback;
};

export const formatCurrencyValue = (value, currency, digits = 2, fallback = "N/A") => {
  if (value === null || value === undefined || value === "") return fallback;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
      currencyDisplay: "symbol",
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(Number(value));
  } catch {
    return `${currency || "USD"} ${value}`;
  }
};

export const formatMoneyValue = (value, currency) => {
  if (value === null || value === undefined || value === "") return "";
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return value;
  const isWhole = Number.isInteger(parsed);
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
      currencyDisplay: "symbol",
      minimumFractionDigits: isWhole ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(parsed);
  } catch {
    return `${currency || "USD"} ${parsed}`;
  }
};

export const formatPriceSummary = (scenario) => {
  const prices = scenario.prices || [];
  if (!prices.length) return "No prices";
  return prices
    .map((price) => {
      const commodityName = price.commodity_detail?.name || price.commodity?.name || "Commodity";
      const priceValue = formatMoneyValue(price.price, scenario.currency);
      return `${commodityName} ${priceValue}`.trim();
    })
    .join(", ");
};
